module.exports = __webpack_public_path__ + "img/speaker-2-3.88c6d3f8.jpg";